import type {
  INotificationsService,
  NotificationBackgroundListenerType,
  NotificationListenerType,
  NotificationTokenListenerType,
} from './NotificationsService';

/**
 * Placeholder service for web
 */
class NotificationsService implements INotificationsService {
  getInitialNotification(): Promise<null> {
    return Promise.resolve(null);
  }
  isPermissionStatusDetermined(): Promise<null> {
    return Promise.resolve(null);
  }
  onNotificationOpenedApp(_: NotificationListenerType): () => void {
    return () => {};
  }
  onMessage(_: NotificationListenerType): () => void {
    return () => {};
  }
  requestPermission(): Promise<null> {
    return Promise.resolve(null);
  }
  getToken(): Promise<string | null> {
    return Promise.resolve(null);
  }
  deleteToken(): Promise<void> {
    return Promise.resolve();
  }
  setBackgroundMessageHandler(
    _: NotificationBackgroundListenerType,
  ): void {}
  onTokenRefresh(_: NotificationTokenListenerType): () => void {
    return () => {};
  }
}

export default new NotificationsService();
